import { Component, OnInit,Input, Inject, PLATFORM_ID, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { WishlistService } from '../../shared/services/wishlist.service';
import { RootService } from 'src/app/shared/services/root.service';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'src/app/shared/services/cookie.service';


@Component({
  selector: 'app-brand-card',
  templateUrl: './brand-card.component.html',
  styleUrls: ['./brand-card.component.scss']
})
export class BrandCardComponent implements OnInit, OnChanges{
@ViewChild('cardElement') cardElement: ElementRef;
  @Input() getPpl: any[]=[];
  @Input() getLob: any;
  @Input() brand:any
  sub: Subscription = new Subscription
  similarProductList: any = [];
  form: any;
  environment1 = environment.s3bucket.url;
  lob_name: any;
  heartUrls = {
    empty: "assets/images/Star-unfilled.svg",
    half: "assets/images/Star-unfilled.svg",
    full: "assets/images/Star-filled.svg"
  };
  ppl_name: any;
  search: any;
  actual_lob_name: any;
  searchValue: any;
  sub_lob: any;
  model: any;

  showLoader: any = false;
  productLoaded: boolean = false;
  isUserLoggedIn: boolean=false;
  @Input() getpl:any;
  @Input() columnFive:any;


  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private rootService: RootService,
    private fb: FormBuilder,private WishlistService: WishlistService,private router: Router,
    private toastrService: ToastrService, public skeletonService: SkeletonService,private behaviorService: BehaviourSubjectService,private ssrcookieService : CookieService,
    private cleverService: ClevertapService, @Inject(PLATFORM_ID) private platformId: Object, private spinner: NgxSpinnerService) {
         this.device_id =this.ssrcookieService.getItem('unbxd.userId') ? this.ssrcookieService.getItem('unbxd.userId') : ''
    this.form = this.fb.group({
      rating: ['', Validators.required],
    });
   }

   slideConfig = {
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    dots: true,
    autoplay: true,
    draggable: true,
    focusOnSelect: true,
    prevArrow: '.client-thumbnails .prev-arrow',
    nextArrow: '.client-thumbnails .next-arrow',
  };
  device_id:any
  ngOnInit(): void {
    setTimeout(() => {
      this.activatedRoute.paramMap.subscribe(params => {
      let vanType = (params.get('lob_name'))?.toLowerCase();
      this.lob_name = (params.get('sub_lob'))?.toLowerCase();
      this.ppl_name = (params.get('ppl_name'))?.toLowerCase();
      this.search = params.get('search');
      this.actual_lob_name = params.get('lob_name');
      this.lob_name = params.get('sub_lob');
      this.ppl_name = params.get('ppl_name');
      this.searchValue = params.get('search');
      if (vanType === "trucks") {
        this.actual_lob_name = (this.lob_name.replace(/\s+/g, '-'))?.toLowerCase()
        this.lob_name = environment.truckLobId
      }
      if (vanType === "buses") {
        this.actual_lob_name = (this.lob_name.replace(/\s+/g, '-'))?.toLowerCase()
        this.lob_name = environment.busLobId
      }
      if (vanType === "scvpickups") {
        this.actual_lob_name = (this.lob_name.replace(/\s+/g, '-'))?.toLowerCase()
        this.lob_name = environment.SCVPickupsLobId
      }
      if (isPlatformBrowser(this.platformId)) {
      if (!window.location.href.includes("Winger")) {
        setTimeout(() => {
          this.getSimilerVehicle()
        }, 2000);
      }
      }
    });
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
    }));
  },2000);

  }
  similarvehiclesOption: OwlOptions = {
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    responsiveRefreshRate: 100,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
   ],
    responsive: {
      0: {
        items: 1.2
      },
      400: {
        items: 1.2
      },
      600: {
        items: 3.2
      },
      940: {
        items: 4.2
      },
      1199:{
        items: 4.2
      }
    },
    nav: true
  }

  getSimilerVehicle() {
    let data = {
      "start_row": 0,
      "end_row": 10,
      // "actual_lob_name":this.getLob ? [this.getLob] : [],
    "ppl_name": this.getPpl ? this.getPpl : [],
    "brand":this.brand ? [this.brand] : []
    }
    if (isPlatformBrowser(this.platformId)) {
      if (window.location.href.includes("winger")) {
        data["pl_name"] = this.getpl ? [this.getpl] : []
        delete data["ppl_name"]
      }
      if (window.location.href.includes("magic")) {
        data["column_five"] = this.columnFive ? [this.columnFive] : []
      }
    }
    let urlPath = this.brand
    .toUpperCase()
    .replace(/ /g, '%20')
    .replace(/\//g, '%3E')
    .replace(/-/g, '%20');
let payload =   {
  "q": urlPath,
  "uid":this.device_id ? this.device_id:'',
  "action_type": "search",
  "start": 0,
  "rows": 9
}
    this.showLoader = true
    this.spinner.show();
    this.sub.add(this.apiService.getsearchUnbxd(payload).subscribe({
      next: (res: any) => {

          this.similarProductList = res?.data?.product_master
            this.showLoader = false;
        this.productLoaded = true

        if (!this.rootService.getUserData()) {
          let wishList: any = [];
          wishList = this.WishlistService.getWishlist();
          if (wishList?.length > 0) {
            wishList.forEach((el: any) => {
              for (let i = 0; i < this.similarProductList?.length; i++) {
                if (el == this.similarProductList[i].id) {
                  this.similarProductList[i].wishlist = true
                }
              }
            })
          }
        }
        for (var i = 0; i < this.similarProductList?.length; i++) {
          this.similarProductList[i].imgData = []
          if (this.similarProductList[i].images?.length > 5) {
            for (var j = 0; j < 5; j++) {
              this.similarProductList[i].imgData.push(this.similarProductList[i].images[j])
            }
          }
          else {
            this.similarProductList[i].imgData = this.similarProductList[i].images
          }
        }
        this.spinner.hide();
       },
      error: () => {
        this.showLoader = false
        this.productLoaded = true
        this.spinner.hide();
       },
    }))
  }

  clickToAddWishlist(event: any) {
    if (this.rootService.getUserData()) {
      let index: any
      for (let e = 0; e < this.similarProductList?.length; e++) {
        if (this.similarProductList[e].id == event) {
          index = this.similarProductList.findIndex((e: any) => e.id == event)
        }
      }
      if (this.similarProductList[index].id == event) {
        if (this.similarProductList[index].wishlist == false) {
          this.similarProductList[index].wishlist = true
          this.addToWishlist(event,'add')
          return
        }
        if (this.similarProductList[index].wishlist == true) {
          this.similarProductList[index].wishlist = false
          this.addToWishlist(event,'delete')
          return
        }
      }
    }
    else {
      this.similarProductList.forEach((e: any) => {
        if (e.id == event)
          e.wishlist = !e.wishlist
      })

      this.WishlistService.addItemToWishList(event)
      let wishList: any = [];
      wishList = this.WishlistService.getWishlist();
      wishList.forEach((el: any) => {
        for (let i = 0; i < this.similarProductList?.length; i++) {
          if (el == this.similarProductList[i].id) {
            this.similarProductList.wishlist = true
          }
          else {
            this.similarProductList.wishlist = false
          }
        }
      })
    }
  }

  addToWishlist(event: any,type:any) {
    let data;
    if(type == 'add'){
    data = {
      "product": [event],
      action_type: "add"
    }
  }else{
    data = {
    "action_type": "delete",
      "product_list": [event]
    }
  }
    this.sub.add(this.apiService.addToWishlist(data).subscribe({
      next: (res: any) => {
    if(type == 'add'){
        this.toastrService.success(res.data.msg)
        this.similarProductList.forEach((e: any) => {
          if (e.id == event) {
            e.wishlist = true
            return
          }
        })
      }else{
        this.toastrService.warning(res.data.msg)

      }
      },
      error: () => { },
      complete: () => { }
    }))
  }


  bookNow(data) {
    if (this.isUserLoggedIn) {
      let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.router.navigate(['/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id]);
    }
    else {
      let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      localStorage.setItem('previousUrl', '/lead-booking/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id)
      this.router.navigate(['/login/']);
    }
    this.clevertapBook(data);
  }

  clevertapBook(productDetailsData: any){
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onBookNowButtonClick(productDetailsData["id"],
          productDetailsData["model"], productDetailsData['images'][0].image_url, "Top Navigation");
      }
      catch { }
    }
}
  redirect(data) {
    let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
    var url = '/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id;
    return url;
  }
  updateImageSize(imageUrl: string, element: HTMLElement, width?: number, height?: number): string {
    if (!isPlatformBrowser(this.platformId)) {
      return imageUrl;
    }
 
    if (!imageUrl) {

      return '';
    }
 
    if (!element) {
      return imageUrl;
    }
 
    try {
      // Get actual width & height of the card
      const actualWidth = width && width > 0 ? width : element.clientWidth || 300;  // Default to 300 if no width
      const actualHeight = height && height > 0 ? height : element.clientHeight || 200;  // Default to 200 if no height
   
    
 
      const imgWidth = Math.floor(actualWidth * 0.8);
      const imgHeight = Math.floor((imgWidth / 100) * 67);
   
    
 
      // Ensure the URL is properly formatted
      const baseUrl = imageUrl.split('/resize/')[0];  // Get the base URL without resize parameters
      if (!baseUrl) {
        return imageUrl;
      }
 
      const updatedUrl = `${baseUrl}/resize/${imgWidth}x${imgHeight}`;
 
      return updatedUrl;
    } catch (error) {
      console.error('Error in updateImageSize:', error);
      return imageUrl;  // Return original URL if there's an error
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)) {
    // if (isPlatformBrowser(this.platformId)) {
    if (changes['getpl'] && !changes['getpl'].firstChange) {
      const pl = changes['getpl'].currentValue;
      this.getpl=pl
      if (window.location.href.includes("winger")) {
        this.getSimilerVehicle();
      }
    }
      if (changes['columnFive'] && !changes['columnFive'].firstChange) {
        const pl = changes['columnFive'].currentValue;
        this.columnFive=pl
        if (window.location.href.includes("magic")) {
          this.getSimilerVehicle();
        }
      }
    }
}

}

